import React from 'react';
import PropTypes from 'prop-types';

import Header from './Header';
import SidebarMenu from './SidebarMenu';
import Body from './Body';
import Footer from './Footer';

const Layout = ({ children }) => (
  <div id="app">
    <Header />
    <SidebarMenu />
    <Body>{children}</Body>
    <Footer />
  </div>
);

Layout.propTypes = {
  children: PropTypes.any.isRequired,
};

export default Layout;



// WEBPACK FOOTER //
// ./src/components/Layout.js